import * as React from "react";

import { kolonne } from "../Component/components"
import { ListeComponent } from "../Component/ListeComponent"
import { navigateToRoute } from "../Component/navigation"
import { ILoaderProps } from "../domene"

import Models = Gf.Web.Models;

export class AktorTabell extends ListeComponent<Models.AktørFeltType, Models.AktørListeModell> {
    constructor(props: ILoaderProps) {
        super(props, "Aktor", "Aktører", r => navigateToRoute(`/Aktor/${r.EntitetId}`));
    }

    getKolonner(model: Gf.Web.Models.AktørListeModell) {
        return [
            kolonne(model, Models.AktørFeltType.Navn, "25%"),
            kolonne(model, Models.AktørFeltType.Epost, "25%"),
            kolonne(model, Models.AktørFeltType.Relasjon, "25%"),
            kolonne(model, Models.AktørFeltType.RelasjonTil, "25%")
        ];
    }
}



// WEBPACK FOOTER //
// ./Scripts/React/Aktor/AktorTabell.tsx